import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';
import headers from '@/constants/headers';

axios.defaults.headers.common.Authorization = `Bearer ${headers.access_token}`;

const foldersService = {
  getFoldersReceived() {
    return axios.get('folders/folders/received');
  },
  getFoldersSearch(page, limit, searchText = '') {
    return axios.get(`${API_V2_URL()}/folders/folders/search?page=${page}&limit=${limit}&q=${searchText}`);
  },
  getFoldersInbox(page, limit, order, sort, searchText = '', folderTypeId = '') {
    return axios.get(`${API_V2_URL()}/folders/folders/inbox?page=${page}&limit=${limit}&order=${order}&sort=${sort}&q=${searchText}&folder_type_id=${folderTypeId}`);
  },
  getFoldersUnreceived(page, limit, order, sort, searchText = '', folderTypeId = '') {
    return axios.get(`${API_V2_URL()}/folders/folders/unreceived?page=${page}&limit=${limit}&order=${order}&sort=${sort}&q=${searchText}&folder_type_id=${folderTypeId}`);
  },
  getFoldersCustom(id, page, limit, order, sort, searchText = '', folderTypeId = '') {
    return axios.get(`${API_V2_URL()}/folders/folder_customs/${id}?page=${page}&limit=${limit}&order=${order}$sort=${sort}&q=${searchText}&folder_type_id=${folderTypeId}`);
  },
  getEmployeeFolders({ id, page = 1, limit = 20, order = 'desc', sort = 'created_at', searchText = '' }) {
    return axios.get(`${API_V2_URL()}/folders/folders/employee/${id}?page=${page}&limit=${limit}&order=${order}&sort=${sort}&q=${searchText}`);
  },
  getFolderTypesOnInbox() {
    return axios.get(`${API_V2_URL()}/folders/folders/folder_types_on_inbox`);
  },
  getFoldersSent(page, limit, searchText = '') {
    return axios.get(`${API_V2_URL()}/folders/folders/sent?page=${page}&limit=${limit}&q=${searchText}`);
  },
  getFoldersArchived(page, limit, searchText = '') {
    return axios.get(`${API_V2_URL()}/folders/folders/archived?page=${page}&limit=${limit}&q=${searchText}`);
  },
  getFoldersToSign() {
    return axios.get(`${API_V2_URL()}/folders/folders/pendency/signatures`);
  },
  getFoldersToReview() {
    return axios.get(`${API_V2_URL()}/folders/folders/pendency/revisions`);
  },
  getFoldersCount() {
    return axios.get(`${API_V2_URL()}/folders/folders/count`);
  },
  getFolder(id) {
    return axios.get(`${API_V2_URL()}/folders/folders/${id}`);
  },
  getFolderTypes() {
    return axios.get('folders/folder_types');
  },
  archiveFolder(id, geolocation, signgoPassword) {
    return axios.post(`${API_V2_URL()}/folders/folders/send_to_archive/${id}`, { geolocation, sign_go_password: signgoPassword });
  },
  receiveFolder(payload) {
    return axios.post(`${API_V2_URL()}/folders/folders/receive_folder`, payload);
  },
  addInterested(folderId, payload) {
    return axios.post(`${API_V2_URL()}/folders/folders/${folderId}/interesteds`, payload);
  },
  addNumber(payload) {
    return axios.post('folders/folders/add_number', payload);
  },
  updateSubject(payload) {
    return axios.post(`${API_V2_URL()}/folders/folders/update_subject`, payload);
  },
  createFolder(folder) {
    return axios.post(`${API_V2_URL()}/folders/folders`, folder);
  },
  destroyFolder(folderId) {
    return axios.delete(`${API_V2_URL()}/folders/folders/${folderId}`);
  },
  sendComment(payload) {
    return axios.post('folders/comments', payload);
  },
  getInteresteds(folderId) {
    return axios.get(`${API_V2_URL()}/folders/folders/${folderId}/interesteds`);
  },
  unlinkDocument(payload) {
    return axios.post('folders/documents/unlink_document', payload);
  },
  downloadFolder(payload) {
    return axios.get(`${API_V2_URL()}/folders/folders/${payload.id}/download`);
  },
  addSigner(payload) {
    return axios.post('folders/documents/create_signers', payload);
  },
  removeSigner(payload) {
    return axios.post(`${API_V2_URL()}/folders/documents/destroy_signature_request`, payload);
  },
  async permittedAdministrativeUnits(folderId) {
    return axios.get(`${API_V2_URL()}/folders/folders/${folderId}/permitted_administrative_units`);
  },
  refuseFolder(folderId, refuseReason, password, geolocation) {
    return axios.post(`${API_V2_URL()}/folders/folders/decline_folder`, {
      folder_id: folderId,
      filled_fields: {
        content: refuseReason,
      },
      password,
      geolocation,
    });
  },

  transactFolder(folderId, payload) {
    return axios.post(`${API_V2_URL()}/folders/folders/${folderId}/transact`, payload);
  },
  transferProcesses({ activeId, inactiveId }) {
    return axios.post(`${API_V2_URL()}/folders/folders/transference`, { active_user_id: activeId, inactive_user_id: inactiveId });
  },
  attachFolders({ folderId, attachedFolders, removedFolders }) {
    return axios.put(`${API_V2_URL()}/folders/folders/${folderId}/attach_folders`, { add: attachedFolders, remove: removedFolders });
  },
};

export default foldersService;



// WEBPACK FOOTER //
// ./src/services/FoldersService.js